import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { StateType } from "../../../../utils/types";
import { getModule } from "../../../../redux/learner/actions";
import {
  selectModules,
  selectModulesLoaded,
  selectModulesLoading,
} from "../../../../redux/learner/selector";

const mapStateToProps = (state: StateType) => ({
  modules: selectModules(state),
  loading: selectModulesLoading(state),
  loaded: selectModulesLoaded(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getModule,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
